export default __webpack_public_path__ + "files/cade72ec5c183a8c13978184c0fe8907.png";